<template>
  <div>
    <div
      class="container-fluid header background-light"
      style="text-align: right; padding-top: 10px"
    ></div>
    <div class="container texto-header posicao-header">
      <h1 class="sombra">{{ title }}</h1>
      <img
        class="bloqueia-arrasto card-logo"
        src="@/assets/img/card-logo.png"
        alt="img"
      />
    </div>
    <div class="container content-box">
      <slot name="content"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "card",

  props: {
    title: {
      type: String,
      required: false
    }
  }
};
</script>

<style lang="scss">
.header {
  background-color: #142260;
  height: 35vh;
}

.texto-header {
  color: white;
  font-size: 2.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.texto-header img {
  margin-left: auto;
  margin-bottom: 20px;
}

.posicao-header {
  margin-top: -23vh !important;
  padding: 0px;
}

.sombra {
  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Card.vue